import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdSenderVerificationSendingDomainsVerifyCacheKeys: AllRouteEndpoints[] = [];
